import React from 'react';
import { inject, observer } from 'mobx-react';
import classnames from 'classnames'

import './stylesheets/messageCenter.scss'
import Language from '../language/language';
import { $const } from '../../helper';
import moment from 'moment'
import { Tooltip } from 'antd'

@inject('languageStore', 'authStore')
@observer
export default class MessageCenter extends React.Component {
  componentDidMount () {
    this.props.authStore.getMessages('all')
  }
  readMessage = (message) => {
    if (message.status !== $const.MESSAGE.READ) {
      this.props.authStore.updateMessage({
        message: {
          status: 'read'
        }
      }, message.id).then(() => {
        this.props.authStore.getMessages('all')
      })
    }
  }

  render () {
    const lang = this.props.languageStore.lang
    const messages = this.props.authStore.messages
    return (
      <div className="message-center-page">
        <div className="title">
          <Language resource="MESSAGE_CENTER" />
        </div>
        <div className="message-list">
          <ul data-perf>
            {messages.map((message) => {
              if (message.message_type === $const.MESSAGE.CODE || message.message_type === $const.MESSAGE.DIVISION) {
                return null
              }
              return (
                <li key={message.id} className={classnames({
                  'un-readed': message.status !== $const.MESSAGE.READ
                })} onClick={this.readMessage.bind(this, message)}>
                  <Tooltip title={lang === 'en' && message.en_content ? message.en_content : message.content}>
                    <div className="msg">
                        <span className="msg-content">
                          {lang === 'en' && message.en_content ? message.en_content : message.content }
                        </span>
                    </div>
                  </Tooltip>
                  <div className="date">{message.created_at ? moment(message.created_at).format('YYYY/MM/DD') : ''}</div>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/message/messageCenter.js